// extracted by mini-css-extract-plugin
export default {"block":"Question_block__n62tp","question":"Question_question__U1rqo"};